export default __webpack_public_path__ + "static/media/0027.41a93ba8.png";